/* eslint-disable react/prop-types */
import React, { useContext, useEffect, useState } from 'react';
import copy from 'copy-to-clipboard';
import UsuarioContext from '../../../context/usuario.context';
import './cadastrosAtivos.scss';
import { notify } from '../../../functions/notifications';
import FirebaseContext from '../../../context/firebase.context';
import CidadesContext from '../../../context/cidades.context';

function CadastrosAtivos() {
  const { usuario: { records } } = useContext(UsuarioContext);
  const { DeleteCadastro } = useContext(FirebaseContext);
  const { setActualLocation } = useContext(CidadesContext);
  const [cadastros, setCadastros] = useState([]);

  useEffect(() => {
    const markers = records ? Object.values(records.marker) : [];
    const poligons = records ? Object.values(records.poligon) : [];
    const listCadastros = [...markers, ...poligons];
    setCadastros(listCadastros);
  }, [records]);

  return (
    <div id="cadastros-ativos-main">
      <div className="title-cadastros-ativos">
        <div className="id-estado-cadastros-ativos">
          <span>
            Certificado.
          </span>
        </div>
        <div className="data-cadastros-ativos">
          <span>
            {window.screen.width < 1000
              ? 'Data'
              : 'Data Cad.'}
          </span>
        </div>
        <div className="tipo-cadastros-ativos">
          <span>
            Tipo Cad.
          </span>
        </div>
        <div className="situacao-cadastros-ativos">
          <span>
            Situação
          </span>
        </div>
        <div className="lat-lng-situacao-cadastros-ativos">
          <span>
            Lat-Lng
          </span>
        </div>
        <div className="actions-cadastros-ativos">
          <span>
            Action
          </span>
        </div>
      </div>
      <div className="content-cadastros-ativos">
        { cadastros
          && cadastros.map((cad) => {
            const key = Object.keys(cad);
            const idEstado = String(cad[`${key}`].idEstado).padStart(4, '0');
            const idUsuario = String(cad[`${key}`].idUsuario).padStart(4, '0');
            return (
              <>
                <div className="id-estado-content-cadastros-ativos">
                  <span>
                    {`AGSF-${idUsuario}-${cad[`${key}`].estado}-${idEstado}`}
                  </span>
                </div>
                <div className="data-content-cadastros-ativos">
                  <span>
                    {cad[`${key}`].dataCad}
                  </span>
                </div>
                <div className="tipo-content-cadastros-ativos">
                  <span>
                    {cad[`${key}`].tipo}
                  </span>
                </div>
                <div className="situacao-content-cadastros-ativos">
                  <span>
                    {cad[`${key}`].active ? 'Ativo' : 'Pendente'}
                  </span>
                </div>
                <div className="content-lat-lng-content-cadastros-ativos">
                  <span>
                    {
                      `${cad[`${key}`].positions[0].lat.toString().substring(0, 7)} /
                      ${cad[`${key}`].positions[0].lng.toString().substring(0, 7)}`
                    }
                  </span>
                  <button
                    onClick={() => {
                      notify('success', 'Coordendas copiadas');
                      copy(`${cad[`${key}`].positions[0].lat}, ${cad[`${key}`].positions[0].lng}`);
                    }}
                    type="button"
                    className="buttons-transparent"
                  >
                    <i className="far fa-copy" />
                  </button>
                </div>
                <div className="actions-content-cadastros-ativos">
                  <div className="visualizar-cadastros-ativos">
                    <button
                      onClick={() => {
                        setActualLocation([
                          cad[`${key}`].positions[0].lat,
                          cad[`${key}`].positions[0].lng]);
                      }}
                      data-dismiss="modal"
                      className="view-content-cadastros-ativos buttons-transparent"
                      type="button"
                    >
                      <i className="far fa-eye" />
                    </button>
                  </div>
                  <div className="excluir-content-cadastros-ativos">
                    <button
                      id={cad[`${key}`].uid}
                      className="view-cadastros-ativos buttons-transparent"
                      type="button"
                      onClick={() => DeleteCadastro({ type: cad[`${key}`].type, uid: cad[`${key}`].uid })}
                    >
                      <i className="far fa-trash-alt" />
                    </button>
                  </div>
                </div>
              </>
            );
          })}
      </div>
    </div>
  );
}

export default CadastrosAtivos;
